const data = [
  {
    id: 1,
    icon: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
    skill: "REACT",
  },

  {
    id: 2,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg",
    skill: "JAVASCRIPT",
  },

  {
    id: 3,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/9/96/Sass_Logo_Color.svg",
    skill: "SASS",
  },

  {
    id: 4,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg",
    skill: "CSS",
  },

  {
    id: 5,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg",
    skill: "HTML",
  },

  {
    id: 6,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/7/7f/Responsive_Web_Design_Logo.svg",
    skill: "RESPONSIVE WEB DESIGN",
  },

  {
    id: 7,
    icon: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Git-logo.svg",
    skill: "GIT",
  },

  {
    id: 8,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg",
    skill: "GITHUB",
  },

  {
    id: 9,
    icon: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
    skill: "FIGMA",
  },
];

export default data;
